<mat-form-field
  appearance="outline"
  class="wideInput"
  [ngClass]="{ 'error-border': customErrorMessage }">

  <mat-label
    [ngClass]="{ 'error-text': customErrorMessage }">
    {{ label }}
  </mat-label>

  <input
    matInput
    [required]="isRequired"
    errorState="textInputField.hasError('required')"
    [formControl]="textInputField"
    id="{{ name }}"
    (keyup)="handleInputEvent($event)">
  
  <mat-error 
    *ngIf="customErrorMessage">
    {{ customErrorMessage }}
  </mat-error>

</mat-form-field>  
